// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import VueCarousel from '@chenfengyuan/vue-carousel'
import Vuex from 'vuex'
import JsonExcel from 'vue-json-excel'
import EnlargeableImage from '@diracleo/vue-enlargeable-image'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

Vue.use(EnlargeableImage)
Vue.component('downloadExcel', JsonExcel)

Vue.use(Vuex)
Vue.component(VueCarousel.name, VueCarousel)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

window.axios = require('axios')
axios.defaults.baseURL = 'https://sarpatnapi.leopardtechlabs.in/'
Vue.prototype.baseURL = "https://sarpatnapi.leopardtechlabs.in/"
// axios.defaults.baseURL = 'https://sarpatnapi.leopardtechlabs.in/'
// Vue.prototype.baseURL = "https://sarpatnapi.leopardtechlabs.in"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js